import { DataMessageResponse_dict_ } from "@/clients/models/DataMessageResponse_dict_";
import { UndoSwapRequest } from "@/clients/models/UndoSwapRequest";
import { PlansService } from "@/clients/services/PlansService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useDeletePlanMealSwap = () => {
  const queryClient = useQueryClient();
  const { mutate, mutateAsync, isPending, isError, error } = useMutation<
    DataMessageResponse_dict_,
    Error,
    UndoSwapRequest
  >({
    mutationKey: [QueryKeys.PLAN_MEAL_SWAP_UNDO],
    mutationFn: async (params: UndoSwapRequest) => {
      const user = guardGetUserFromLocalStorage();
      return PlansService.undoMealSwapApiV1PlansMealSwapDelete(user.id, {
        day: params.day,
        mealId: params.mealId,
        mealTime: params.mealTime,
        mealIndex: params.mealIndex,
        targetDate: params.targetDate ?? undefined,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.PLAN] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.BALANCE_CALORIES] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.BALANCE_PROTEIN] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.SHOPPING_LIST] });
    },
  });

  return {
    deletePlanMealSwap: mutate,
    deletePlanMealSwapAsync: mutateAsync,
    isLoading: isPending,
    isError,
    error,
  };
};
